import React from 'react';
import { cn } from '@/lib/utils';

const Heading = ({ children, className }) => {
  return (
    <h1
      className={cn(
        'mb-4 text-center font-manrope text-[24px] font-extrabold capitalize leading-[34px] tracking-normal text-black',
        'md:mb-8 md:text-left md:text-[42px] md:leading-[54px]',
        className,
      )}
    >
      {children}
    </h1>
  );
};

export default Heading;
